<template>
    <div>
        <div class="autocomplete mb-3">
            <label>Personne morale à associer à la société</label>
            <b-form-input
                v-model="search"
                type="text"
                placeholder="Saisissez le nom ou le SIREN de la personne morale recherchée"
                size="sm"
                @input="onChange"
            />
            <ul
                v-show="isOpen"
                id="autocomplete-results"
                class="autocomplete-results"
            >
                <li v-if="isLoading" class="loading">
                    <i class="fas fa-spinner" spin></i>
                    Recherche en cours
                </li>
                <li
                    v-for="(moralPerson, i) in moralPersons"
                    v-if="!isLoading"
                    :key="i"
                    class="autocomplete-result"
                    :class="{ 'is-active': i === arrowCounter }"
                    @click="setAssociate(moralPerson)"
                >
                    {{ moralPersonDetails(moralPerson) }}
                </li>
            </ul>
        </div>
        <b-alert :show="showNoResult" variant="secondary">
            Aucune personne morale n'a été trouvée dans la base de données. Vous
            pouvez en créer une nouvelle
        </b-alert>
        <b-button variant="secondary" size="sm" @click="resetStatus">
            <i class="fas fa-times fa-fw"></i> Annuler
        </b-button>
        <b-button
            v-if="showNoResult"
            variant="success"
            size="sm"
            @click="showCreate"
        >
            <i class="fas fa-plus fa-fw"></i> Créer une personne morale
        </b-button>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'MoralPersonSearch',

    data() {
        return {
            isOpen: false,
            moralPersons: [],
            clientId: '',
            search: '',
            isLoading: false,
            arrowCounter: 0,
            hasResult: false,
            showNoResult: false,
            form: {},
        }
    },

    methods: {
        resetStatus() {
            this.$store.commit('legalVM/RESET_STATUS')
        },

        showCreate() {
            this.$store.commit('legalVM/SHOW_CREATE')
        },

        onChange() {
            this.getPhysicalPersons()
        },

        async getPhysicalPersons() {
            try {
                this.showNoResult = false
                this.isOpen = true
                this.isLoading = true
                const response = await axios.get(
                    `/moralPersons/search/${this.search}`
                )
                this.moralPersons = response.data.data
                this.showNoResult = response.data.data.length === 0
                this.isLoading = false
                this.checkResults()
            } catch (error) {
                // handle error
                console.log(error)
            }
        },

        moralPersonDetails(moralPerson) {
            return `${moralPerson.name} - ${moralPerson.zip_code} ${moralPerson.city} | ${moralPerson.registration_number}`
        },

        async setAssociate(moralPerson) {
            this.search = this.moralPersonDetails(moralPerson)
            this.form.client_id = this.client.id
            this.form.moral_person_id = moralPerson.id
            try {
                const response = await axios.post(
                    `/${this.linkType}/moralPersons/set`,
                    this.form
                )
                this.$store.commit('legalVM/SET_CLIENT', response.data.data)
                this.$store.commit('legalVM/RESET_STATUS')
            } catch (error) {
                // handle error
                console.log(error)
            }
        },

        checkResults() {
            if (this.noResult) {
                this.isOpen = false
            }
        },
    },

    computed: {
        ...mapState({
            client: (state) => state.legalVM.client,
            searching: (state) => state.legalVM.searching,
            linkType: (state) => state.legalVM.linkType,
        }),
        noResult() {
            return this.moralPersons.length === 0
        },
    },
}
</script>

<style scoped>
.autocomplete {
    position: relative;
}

.autocomplete-results {
    padding: 0;
    margin: 0;
    border: 1px solid #eeeeee;
    height: 150px;
    overflow: auto;
    background-color: #fff;
}

.autocomplete-result {
    font-size: 12px;
    list-style: none;
    text-align: left;
    padding: 4px 12px;
    cursor: pointer;
}

.autocomplete-result:hover {
    background-color: #98be12;
    color: #ffffff;
}

.loading {
    list-style: none;
    text-align: center;
    padding: 0;
    cursor: none;
    margin-top: 20px;
}
</style>
